import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { MerchantSiteViewModel } from '@app/api/models';
import {
  MerchantActions,
  MerchantSelectors,
} from '@merchant/store/merchant.slice';
import { Unit } from '@products/interfaces/unit';
import { SearchCategorySelectComponent } from '@search/components/search-category-select/search-category-select.component';
import { CheckboxSubformComponent } from '@search/components/sub-components/checkbox-subform/checkbox-subform.component';
import { SelectorSubformComponent } from '@search/components/sub-components/selector-subform/selector-subform.component';
import { TextInputSubformComponent } from '@search/components/sub-components/text-input-subform/text-input-subform.component';
import { CustomerSegmentSubformComponent } from '@shared/components/customer-segment-subform/customer-segment-subform.component';
import { SearchLayoutComponent } from '@shared/components/search-layout/search-layout.component';
import { paginatorConfiguration } from '@shared/constants/paginator-configuration';
import { AvailabilityStatusTypes } from '@shared/interfaces/availability-status.type';
import { SearchFilter } from '@shared/interfaces/search-filter.interface';
import { ProductSortimentActions } from '@sortiment/store/product-sortiment.slice';

@Component({
  selector: 'app-vip-discounts-with-search',
  templateUrl: './vip-discounts-with-search.component.html',
  styleUrls: ['./vip-discounts-with-search.component.scss'],
})
export class VipDiscountsWithSearchComponent implements OnInit, AfterViewInit {
  @ViewChild('searchLayout') searchLayout!: SearchLayoutComponent;
  searchFieldList: Array<SearchFilter> = [];
  searchAction = ProductSortimentActions.loadProductSortiment;
  updateSearchValueAction = ProductSortimentActions.updateFilter;
  pageSize = paginatorConfiguration.sortimentPageSizeOptions[0];

  subs = new SubSink();

  sitesLoaded$ = this.store.select(MerchantSelectors.selectSitesLoaded);
  siteList?: MerchantSiteViewModel[];

  constructor(private store: Store, private router: Router) {}

  ngOnInit(): void {
    this.store.dispatch(MerchantActions.loadSites.trigger());

    this.subs.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.url === '/selling/prices/discounts/vip-discounts/given') {
            this.searchLayout.isSidenavOpen = false;
            this.searchLayout.showPanel = false;
          } else {
            this.searchLayout.isSidenavOpen = true;
            this.searchLayout.showPanel = true;
          }
        }
      })
    );

    this.subs.add(
      this.store
        .select(MerchantSelectors.selectSiteList)
        .subscribe((sites: MerchantSiteViewModel[]) => {
          this.siteList = sites;
        })
    );

    this.sitesLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.searchFieldList = [
          {
            name: SearchCategorySelectComponent,
            title: 'SEARCH.SEARCH_BAR.TITLE.DRINK_TYPE',
            property: 'drinkTypeList',
            isGeneric: true,
          },
          {
            name: TextInputSubformComponent,
            title: 'PRODUCTS.TITLE.BRAND',
            property: 'brand',
            isGeneric: true,
          },
          {
            name: TextInputSubformComponent,
            title: 'PRODUCTS.TITLE.NAME',
            property: 'name',
            isGeneric: true,
          },
          {
            name: TextInputSubformComponent,
            title: 'PRODUCTS.TITLE.NET_AMOUNT',
            property: 'amount',
            isGeneric: true,
            data: { type: 'number', maxDecimals: 10 },
          },
          {
            name: SelectorSubformComponent,
            title: 'PRODUCTS.TITLE.UNIT',
            property: 'unit',
            isGeneric: true,
            data: {
              enum: Object.values(Unit).map((unit) => ({
                name: 'PRODUCTS.UNIT.' + unit,
                value: unit,
              })),
              labelAttribute: 'name',
              valueAttribute: 'value',
              isMultiple: false,
            },
          },
          {
            name: SelectorSubformComponent,
            title: 'PRODUCTS.TITLE.COLLECTION_UNIT',
            property: 'hasCollectionPackaging',
            isGeneric: true,
            data: {
              enum: [
                { name: 'PRODUCTS.COLLECTION_UNIT.OPTIONS.TRUE', value: true },
                {
                  name: 'PRODUCTS.COLLECTION_UNIT.OPTIONS.FALSE',
                  value: false,
                },
              ],
              labelAttribute: 'name',
              valueAttribute: 'value',
              isMultiple: false,
            },
          },
          {
            name: TextInputSubformComponent,
            title: 'PRODUCTS.TITLE.EAN',
            property: 'ean',
            isGeneric: true,
            data: { type: 'number' },
          },
          {
            name: CheckboxSubformComponent,
            title: 'SHARED.TITLE.SITE',
            property: 'siteIds',
            isGeneric: true,
            data: {
              checkboxOptions: this.siteList?.map((site) => site.name),
              optionIds: this.siteList?.map((site) => site.id),
            },
          },
          {
            name: CheckboxSubformComponent,
            title: 'SHARED.TITLE.STATUS',
            property: 'availabilityStatus',
            isGeneric: true,
            data: {
              checkboxOptions: AvailabilityStatusTypes,
              optionTitlePrefix: 'SHARED.STATUS.',
              isSingle: true,
            },
          },
          {
            name: CustomerSegmentSubformComponent,
            title: 'SHARED.TITLE.CUSTOMER_SEGMENT',
            property: '',
            isGeneric: true,
          },
        ];
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.router.url === '/selling/prices/discounts/vip-discounts/given') {
      this.searchLayout.isSidenavOpen = false;
      this.searchLayout.showPanel = false;
    }
  }
}
